import { Component, input, viewChildren, effect } from '@angular/core';
import { Activity, ContentType } from '@mira-avant/mtlibs';
import { NavigationService } from '../../../../services/navigation.service';
import { H5pPlayerComponent } from './h5p-player/h5p-player.component';
import { HubsPlayerComponent } from './hubs-player/hubs-player.component';
import { RichTextPlayerComponent } from './rich-text-player/rich-text-player.component';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'app-player',
	standalone: true,
	imports: [H5pPlayerComponent, HubsPlayerComponent, RichTextPlayerComponent, CommonModule],
	templateUrl: './player.component.html',
	styleUrl: './player.component.scss',
})
export class PlayerComponent {
	// Used for debugging in the CMS
	dontTrackTake = input<boolean>(false);
	activity = input<Activity | undefined>();

	h5ps = viewChildren(H5pPlayerComponent);

	ContentType = ContentType;

	private recursiveH5pActivateIndex = 0;

	constructor(public nav: NavigationService) {
		effect(() => {
			const players = this.h5ps();
			if (players.length > 0) {
				this.recursiveH5pActivateIndex = 0;
				this.activateNextH5p();
			}
		});
	}

	onH5pReady(index: number, ready: boolean) {
		if (ready && index === this.recursiveH5pActivateIndex) {
			this.recursiveH5pActivateIndex++;
			this.activateNextH5p();
		}
	}

	private activateNextH5p(): void {
		const players = this.h5ps();

		if (players.length === 0) {
			return;
		}

		const index = this.recursiveH5pActivateIndex;

		if (index >= players.length) {
			return;
		}

		const playerToActivate = players[index];

		setTimeout(() => {
			playerToActivate.activate();
		}, 500);
	}
}
